import { style } from 'typestyle';
import {
    COLOR_06,
    COLOR_21,
    COLOR_24,
    COLOR_34,
    COLOR_35,
    DESKTOP_PAGE_FOOTER_HEIGHT_PX,
    DESKTOP_PAGE_MENU_HEIGHT_PX,
    MARGINS_PX,
    PAGE_CONTENT_ZINDEX,
    PAGE_FOOTER_HEIGHT_PX,
    PAGE_MENU_HEIGHT_PX,
    TABLET_PAGE_FOOTER_HEIGHT_PX,
    TABLET_PAGE_MENU_HEIGHT_PX
} from '../../../constants';
import {
    desktopStyles,
    styleOverride,
    tabletStyles
} from '../../../utils';

export const pageClassName = style({
    $debugName: 'page.component',
    
    display: 'block',
    position: 'relative',
    boxSizing: 'border-box',
    zIndex: PAGE_CONTENT_ZINDEX,
    margin: '0 auto',
    padding: `${PAGE_MENU_HEIGHT_PX}px 0 ${PAGE_FOOTER_HEIGHT_PX}px`,
    width: '100%',
    minHeight: '100vh',
    overflowX: 'hidden',
    overflowY: 'auto',

    $nest: {
        'hr': {
            display: 'block',
            width: '100%',
            margin: `${MARGINS_PX}px 0`,
            height: '1px',
            border: 0,
            backgroundColor: COLOR_21,
        }
    }
}, tabletStyles({
    padding: `${TABLET_PAGE_MENU_HEIGHT_PX}px 0 ${TABLET_PAGE_FOOTER_HEIGHT_PX}px`
}), desktopStyles({
    padding: `${DESKTOP_PAGE_MENU_HEIGHT_PX}px 0 ${DESKTOP_PAGE_FOOTER_HEIGHT_PX}px`
}));

export const pageInnerClassName = style({
    position: 'relative',
    backgroundColor: 'transparent',
    minHeight: `calc(100vh - ${PAGE_MENU_HEIGHT_PX + PAGE_FOOTER_HEIGHT_PX}px)`,
    zIndex: 2,
    transition: 'background-color 800ms linear',
}, tabletStyles({
    minHeight: `calc(100vh - ${TABLET_PAGE_MENU_HEIGHT_PX + TABLET_PAGE_FOOTER_HEIGHT_PX}px)`
}), desktopStyles({
    minHeight: `calc(100vh - ${DESKTOP_PAGE_MENU_HEIGHT_PX + DESKTOP_PAGE_FOOTER_HEIGHT_PX}px)`
}));

export const pageBackgroundChildrenClassName = style({
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 0,

    $nest: {
        [`& + .${pageInnerClassName}`]: {
            background: 'transparent'
        }
    }
});

export const pageInnerVcenteredClassName = style({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center'
}, tabletStyles({
}), desktopStyles({
}));

export const pageThemeBlueClassName = styleOverride(
    null,
    {'hr': {backgroundColor: COLOR_24}},
    [pageInnerClassName, {backgroundColor: COLOR_06}]
);

export const pageThemeGreenClassName = styleOverride(
    null,
    {'hr': {backgroundColor: COLOR_35}},
    [pageInnerClassName, {backgroundColor: COLOR_34}]
);

export const pageWithoutHeaderClassName = style({
    padding: `0 0 ${PAGE_FOOTER_HEIGHT_PX}px`,

    $nest: {
        [`.${pageInnerClassName}`]: {
            minHeight: `calc(100vh - ${PAGE_FOOTER_HEIGHT_PX}px)`
        }
    }
}, tabletStyles({
    padding: `0 0 ${TABLET_PAGE_FOOTER_HEIGHT_PX}px`,

    $nest: {
        [`.${pageInnerClassName}`]: {
            minHeight: `calc(100vh - ${TABLET_PAGE_FOOTER_HEIGHT_PX}px)`
        }
    }
}), desktopStyles({
    padding: `0 0 ${DESKTOP_PAGE_FOOTER_HEIGHT_PX}px`,

    $nest: {
        [`.${pageInnerClassName}`]: {
            minHeight: `calc(100vh - ${DESKTOP_PAGE_FOOTER_HEIGHT_PX}px)`
        }
    }
}));
